// Change this to the same value as `basePath` in next.config.mjs if specified.
export const BasePath = '';

export const IconIds = {
  admin: 'mdi:administrator',
  dashboard: 'mdi:view-dashboard',
  people: 'mdi:people',
  workflows: 'mdi:arrow-right-circle-outline',
  communications: 'mdi:send-outline',
  organization: 'mdi:world-wide-web',
  reminders: 'mdi:bell-outline',
};
